export const getListHeight = (amount: number, hasErrorFiles: boolean) => {
  let resultHeight = 0;

  if (!amount) {
    return resultHeight;
  }

  if (amount === 1) {
    resultHeight = 40;
  }

  if (amount === 2) {
    resultHeight = 88;
  }

  if (amount >= 3) {
    resultHeight = 136;
  }

  if (hasErrorFiles) {
    resultHeight += 20;
  }

  return resultHeight;
};
